import React, { useCallback /*, useEffect, useContext*/ } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdButton from '../../common/elemental/AfitdButton';
import { CONFIRM_DIALOG_TITLE_ADD_NEW_COMPANY_TO_CURRENT_ACCOUNT } from '../../common/constants';

// import cx from 'clsx';
// import _get from 'lodash/get';

const styles = theme => ({
    root: {},
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '600',
    },
    contentText: {
        color: '#111E14',
        fontSize: '1rem',
        fontWeight: 400,
    },
});

const getDefns = params => {
    const { props, handleClickLogOutButton, handleClickNoButton, handleClickYesButton } = params;
    const { classes, open, logOutButtonLabel = 'Log Out', noButtonLabel = 'Cancel', yesButtonLabel = 'Yes', yesButtonColor = 'default' } = props;

    const defns = {
        root: {
            open,
            maxWidth: false,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
        },
        logOutButton: {
            onClick: handleClickLogOutButton,
            label: logOutButtonLabel,
        },
        noButton: {
            onClick: handleClickNoButton,
            label: noButtonLabel,
        },
        yesButton: {
            onClick: handleClickYesButton,
            label: yesButtonLabel,
            color: yesButtonColor,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const ConfirmAddNewCompanyDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { classes, email, open, onLogOut, onClose, onConfirm, yesButtonLabel, noButtonLabel, yesButtonColor, hideNoButton, ...otherProps } = props;
    const { paperScrollPaper: paperScrollPaperCls, content: contentCls } = classes;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const closeDialog = useCallback(() => {
        onClose && onClose();
    }, [onClose]);

    const handleClickLogOutButton = useCallback(() => {
        onLogOut && onLogOut();
        closeDialog();
    }, [onLogOut, closeDialog]);

    const handleClickNoButton = useCallback(() => {
        closeDialog();
    }, [closeDialog]);

    const handleClickYesButton = useCallback(() => {
        onConfirm && onConfirm();
        closeDialog();
    }, [onConfirm, closeDialog]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, open, handleClickLogOutButton, handleClickNoButton, handleClickYesButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Dialog aria-labelledby="confirm-dialog" aria-describedby="confirm-dialog" {...defns.root} {...otherProps} classes={{ paperScrollPaper: paperScrollPaperCls }}>
            <DialogTitle id="confirm-dialog-title">
                <b>{CONFIRM_DIALOG_TITLE_ADD_NEW_COMPANY_TO_CURRENT_ACCOUNT}</b>
            </DialogTitle>
            <DialogContent className={contentCls}>
                <DialogContentText
                    id="confirm-dialog-description"
                    classes={{
                        root: classes.contentText,
                    }}
                >
                    Would you like to link the new company to the current account (<span style={{ fontWeight: 'bold' }}>{email}</span>)?
                    <br />
                    <br />
                    (If you want to use a different email address, click 'Log Out' to create a new employer account)
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <AfitdButton label="Log Out" {...defns.logOutButton} />
                <AfitdButton label="Cancel" {...defns.noButton} />
                <AfitdButton label="Yes" {...defns.yesButton} />
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(ConfirmAddNewCompanyDialog);
